import { useNextScreening } from '@/api/queries'
import { ErrorState } from '@/components/ui/EmptyState'
import { Widget } from '@/components/ui/Widget'
import { dateTime } from '@/lib/format'
import { delayLevel, delayMinutes, formatDuration } from './nextScreening'
import styles from './NextScreeningWidget.module.css'

export function NextScreeningWidget({ className }: { className?: string }) {
  const { data, isLoading, error } = useNextScreening()
  const delay = delayMinutes(data?.delayTime ?? null)
  const isLate = delay > 0
  const level = data ? delayLevel(data) : null

  return (
    <Widget title="RateScreener · next synchronisation" loading={isLoading} className={className}>
      {error ? (
        <ErrorState error={error} />
      ) : (
        <div className={styles.boxes}>
          <div className={styles.box}>
            <div className={styles.label}>Next screening</div>
            <div className={styles.value}>{data ? dateTime(data.scheduledAt, 'yyyy-MM-dd HH:mm') : '–'}</div>
          </div>
          <div className={`${styles.box} ${level === 'critical' ? styles.danger : level === 'warning' ? styles.warn : ''}`}>
            <div className={styles.label}>{isLate ? 'Delay' : 'Remaining'}</div>
            <div className={styles.value}>{isLate ? formatDuration(data!.delayTime) : formatDuration(data?.remainingTime ?? null)}</div>
          </div>
          <div className={styles.box}>
            <div className={styles.label}>Continents</div>
            <div className={`${styles.value} ${styles.small}`}>{data?.timezones.length ? data.timezones.join(', ') : '–'}</div>
          </div>
          <div className={styles.box} title={data?.notRunningHotelIds.length ? `Not started: ${data.notRunningHotelIds.slice(0, 20).join(', ')}${data.notRunningHotelIds.length > 20 ? '…' : ''}` : undefined}>
            <div className={styles.label}>Customers</div>
            <div className={styles.value}>
              {data ? (data.runningCustomers || data.notRunningCustomers ? `${data.runningCustomers} / ${data.customers}` : data.customers) : '–'}
              {data && data.notRunningCustomers > 0 && <span className={`${styles.small} u-warn`}> · {data.notRunningCustomers} not started</span>}
            </div>
          </div>
        </div>
      )}
    </Widget>
  )
}
